module.exports = __webpack_public_path__ + "img/TinyTAN_Permission_to_Dance_03.7ccd0848.png";